/* import __COLOCATED_TEMPLATE__ from './project-cancel.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, getProperties } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency';
import { closeModal } from 'sh-www/utils/modal-controls';
import { validateSchema } from 'sh-www/utils/validators';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';
import { string, object } from 'yup';

const SCHEMA = object({
  'comment': string().test(
    'comment-is-empty-or-min-five-char-test',
    'Comment must be at least 5 characters if provided.',
    comment => !comment || comment.length >= 5,
  )
});

const FORM_INPUTS = ['comment', 'generic-exception'];

class AdminProjectCancelModalComponent extends Component {
  @service('commands.application-commands') applicationCommandService;
  @service('state-managers.application') applicationStateManager;

  @tracked comment = '';
  @tracked errors = {};

  @action
  onCommentChange(value) {
    this.comment = value;
  }

  @dropTask
  *handleSubmit() {
    try {
      const [_, validationErrors = {}] = validateSchema(getProperties(this, Object.keys(SCHEMA.fields)), SCHEMA);
      this.errors = validationErrors;

      if (Object.values(this.errors).every(error => !error)) {
        yield this.applicationCommandService.cancelApplication(
          this.args.model.application,
          null,
          '',
          this.comment
        );
        this.args.model.reloadApplicationCallback();
        this.applicationStateManager.addToast('Project canceled');
        closeModal(this);
      }
    } catch (error) {
      handleErrorResponse(this, error, FORM_INPUTS, false);
    }
  }
}

export default AdminProjectCancelModalComponent;
